import React from "react";
import { Icon } from "../../Icon";
// import svgString from './id-gov-ua-diia.svg'; // Assuming the SVG is in the same directory

const DiaProvider = ()=>{
  const kepClick = () => {
    let state = '';
    function uuidv4() {
      return (state = ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16),
      ));
    }
    uuidv4();
    localStorage.setItem('state', state);
    console.log(`https://id.gov.ua/?response_type=code&client_id=9ec247b489c29db2bcbb7a57520c8e7e&auth_type=dig_sign,bank_id,diia_id&state=${state}&redirect_uri=https://ap.sportforall.gov.ua/loginTest`)
    window.open(
      `https://id.gov.ua/?response_type=code&client_id=9ec247b489c29db2bcbb7a57520c8e7e&auth_type=dig_sign,bank_id,diia_id&state=${state}&redirect_uri=https://ap.sportforall.gov.ua/loginTest`,
      '_blank'
    );
  };

    return(<>
        <button
          className="btn-primary text-btn-primary buttonDia"
          style={{
            backgroundColor: 'black',
            padding: '5px 8px 5px 8px;',
            width:'41px',
            border: '1px solid #E8E8E8',
            borderRadius: '50%',
            marginTop: '0'
        }
        }
          type="button"
          onClick={kepClick}
        >
           <Icon type='DIA'></Icon>
        </button>
    </>)
}

export default DiaProvider;